import React from 'react';
import { RentalManagerEnvironmentContext } from '../components/RentalManagerEnvironmentProvider';

export const useStaticApp = () => {
  const { environment } = React.useContext(RentalManagerEnvironmentContext);
  const staticApp = React.useMemo(() => {
    return {
      isNodeLess: environment.isNodeLess || false,
      initialAuthComplete: environment.initialAuthComplete,
    };
  }, [environment]);

  return staticApp;
};
